// extracted by mini-css-extract-plugin
export default {"btn-override":"CaptureVisa_style_btn-override__QfyJT","wrapper":"CaptureVisa_style_wrapper__wObuy","rotate":"CaptureVisa_style_rotate__zAiMP"};